import * as z from "zod/v4";

export const getAccountingOAuthUrl = {
  name: "getAccountingOAuthUrl" as const,
  input: z.null(),
  output: z.object({ url: z.string() }),
};
